import { regionApi, regionRequest } from './regionApi';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const regionHaApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    getRegionsHaList: build.query<any, Record<string, any>>({
      async queryFn(arg, _api, _extraOptions, fetchWithBQ) {
        const results = await Promise.all(
          (arg?.regions || []).map(async (region: Record<string, any>) => {
            const res = await fetchWithBQ(
              regionRequest(region, 'ha', {
                method: 'GET',
                params: {
                  account_id: arg?.account_id,
                  user_id: arg?.user_id,
                  access_from_user_id: arg?.access_from_user_id,
                  group_id: arg?.group_id
                }
              })
            );

            return res.data
              ? { data: res.data, region }
              : { error: res.error as FetchBaseQueryError, region };
          })
        );

        return { data: results };
      },

      providesTags: ['HA']
    }),

    /* ---------------------------------------------------- */

    getHa: build.query<any, Record<string, any>>({
      query: ({ region, ha_id }) =>
        regionRequest(region, `ha/${ha_id}`, {
          method: 'GET'
        })
    }),

    /* ---------------------------------------------------- */

    createHa: build.mutation<any, any>({
      query: ({ region, ha_id, data }) =>
        regionRequest(region, ha_id ? `ha/${ha_id}` : 'ha', {
          method: ha_id ? 'PUT' : 'POST',
          body: data
        }),

      invalidatesTags: ['HA', 'RegionInstance']
    }),

    /* ---------------------------------------------------- */

    updateHa: build.mutation<any, any>({
      query: ({ region, ha_id, data }) =>
        regionRequest(region, `ha/${ha_id}`, {
          method: 'PUT',
          body: data
        })
    })
  })
});

export const {
  useGetRegionsHaListQuery,
  useLazyGetRegionsHaListQuery,
  useGetHaQuery,
  useCreateHaMutation,
  useUpdateHaMutation
} = regionHaApi;
